import './SLayout.scss';

const SFooter = () => {
  const currentYear = new Date().getFullYear();
  return (
    <section className="footer align-items-center text-center d-flex justify-content-center">
      <div className="text-white">
        &copy; {currentYear} Strides Premier Private Hire and Limousine Pte. Ltd. |&nbsp;
        <a href="https://stridespremier.com.sg/terms-of-use/" target="_blank" rel="noreferrer">
          <u className="text-white">Terms of Use</u>
        </a>
        &nbsp;|&nbsp;
        <a href="https://stridespremier.com.sg/privacy-policy/" target="_blank" rel="noreferrer">
          <u className="text-white">Privacy Policy</u>
        </a>
      </div>
    </section>
  );
};

export default SFooter;
